'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var cx = require('classnames');
var alloyProductCards_module = require('./alloy-product-cards.module.scss.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var cx__default = /*#__PURE__*/_interopDefault(cx);

/**
 * This component has been deprecated. Please see <Card>
 * @deprecated
 */
var CardItem = function (_a) {
    var _b;
    _a.variant; var type = _a.type, hideXS = _a.hideXS, hideXL = _a.hideXL, className = _a.className, children = _a.children, props = tslib.__rest(_a, ["variant", "type", "hideXS", "hideXL", "className", "children"]);
    var compClasses = cx__default.default(className, (_b = {
            'd-none d-sm-block': hideXS,
            'd-lg-none d-xl-none': hideXL
        },
        _b["".concat(alloyProductCards_module.default[type])] = type,
        _b));
    var stdInc = tslib.__assign({ 'data-testid': type ? "card-item-".concat(type) : "card-item-any", className: compClasses }, props);
    var itemTypes = {
        img: jsxRuntime.jsx("div", tslib.__assign({}, stdInc, { children: children })),
        attribute: jsxRuntime.jsx("div", tslib.__assign({}, stdInc, { children: children })),
        linkCard: jsxRuntime.jsx("div", tslib.__assign({}, stdInc, { children: children })),
        title: jsxRuntime.jsx("h3", tslib.__assign({}, stdInc, { children: children })),
        price: jsxRuntime.jsx("h3", tslib.__assign({}, stdInc, { children: children })),
        text: jsxRuntime.jsx("p", tslib.__assign({}, stdInc, { children: children }))
    };
    return jsxRuntime.jsx(jsxRuntime.Fragment, { children: type ? itemTypes[type] : jsxRuntime.jsx("div", tslib.__assign({}, stdInc, { children: children })) });
};

exports.CardItem = CardItem;
//# sourceMappingURL=CardItem.js.map
